import Vue from 'vue';

Vue.prototype.$isNotNullOrUndefined = value => {
  return typeof value !== 'undefined' && value;
};
Vue.prototype.$isNullOrUndefined = value => {
  return value === null || typeof value === 'undefined';
};

Vue.prototype.$firstOrDefault = value => {
  return Vue.prototype.$isNotNullOrUndefined(value) ? value[0] : null;
};

Vue.prototype.$getRandomString = len => {
  let charSet =  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var randomString = '';
  for (var i = 0; i < len; i++) {
      var randomPoz = Math.floor(Math.random() * charSet.length);
      randomString += charSet.substring(randomPoz,randomPoz+1);
  }
  return randomString;
}
// Global registry and single listener
const els = new Set()
const callbacks = new WeakMap()
let listening = false

function onDocClick(e) {
    const path = e.composedPath ? e.composedPath() : null

    // Is the click inside any registered element?
    const isInsideAny = Array.from(els).some(el => el === e.target || el.contains(e.target))

    if (isInsideAny) return

    // Click is outside all registered elements -> notify each
    els.forEach(el => {
        const cb = callbacks.get(el)
        if (typeof cb === 'function') cb(e)
    })
}

Vue.directive('click-outside', {
    bind(el, binding) {
        els.add(el)
        callbacks.set(el, binding.value)
        if (!listening) {
            document.addEventListener('click', onDocClick, true) // capture
            listening = true
        }
    },
    update(el, binding) {
        callbacks.set(el, binding.value)
    },
    unbind(el) {
        els.delete(el)
        callbacks.delete(el)
        if (els.size === 0 && listening) {
            document.removeEventListener('click', onDocClick, true)
            listening = false
        }
    },
})